import QRCode from 'qrcode';

// What is specific to the rate-chart poster: its fonts and its QR code. Capture, download, PDF, print and the logo upload are
// shared by every poster editor — see utils/posterExport.js.

// ── fonts ─────────────────────────────────────────────────────────────────
// The poster draws its title and shop name in Anek Bangla and everything else in Hind Siliguri. Both are already loaded
// app-wide (index.html's Google Fonts link), but a browser only fetches the glyph ranges a page actually uses — so before a
// capture the poster asks for the ones it needs and waits for them.
const FONT_SAMPLE = 'রেট চার্ট সেবা মূল্য 0123456789 Rate Chart Service';

/** Loads the poster's glyphs and waits until they are ready. Never rejects — a missing font just falls back. */
export function loadPosterFonts() {
    if (typeof document === 'undefined' || !document.fonts) return Promise.resolve();
    return Promise.all([
        document.fonts.load('700 24px "Anek Bangla"', FONT_SAMPLE),
        document.fonts.load('500 14px "Hind Siliguri"', FONT_SAMPLE),
        document.fonts.load('600 14px "Hind Siliguri"', FONT_SAMPLE),
        document.fonts.load('700 14px "Hind Siliguri"', FONT_SAMPLE),
    ])
        .catch(() => {})
        .then(() => document.fonts.ready)
        .catch(() => {});
}

// ── small inputs ──────────────────────────────────────────────────────────
/** A QR code as a PNG data URL ('' when there is nothing to encode). */
export async function makeQrDataUrl(text) {
    if (!text) return '';
    try {
        return await QRCode.toDataURL(text, { margin: 0, width: 256, errorCorrectionLevel: 'M' });
    } catch {
        return '';
    }
}
